import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  //useMessageHandler,
} from "../../reusableComponent/Reusables";
import {
  editDeleteCylinderTagMap,
  getCylinderTagMapList,
} from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import cylinderTagNoMasterService from "../../../services/masters/cylinderTagNoMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const ListCyltagmap = () => {
  const dispatch = useDispatch();

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [sortBy, setSortBy] = useState("cylinder_no");
  const [sortOrder, setSortOrder] = useState("asc");
    const [fileUploadError, setFileUploadError] = useState("");

  const totalCount = useSelector(state => state.cylinder_tag_mapping.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.cylinder_tag_mapping.rows_per_page || 15);
  // const rows = useSelector((state) => state.cylinder_tag_mapping.CylinderTagMapping);
  const [rows, setRows] = useState([]);
  const respMsgState = useSelector((state) => state?.CylinderTagMapping?.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [successMessage, setSuccessMessage] = useState(null);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });
  const handleFileChange = (e) => {
    handleImportExcel(e);
  };
   const handleImportExcel = (e) => {
    const file = e.target.files[0];
    setFileUploadError("");
    if (!file) return;

    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!["xlsx", "xls", "csv"].includes(fileExtension)) {
      setFileUploadError("Please upload a valid Excel file (.xlsx, .xls, or .csv)");
      return;
    }
  }

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  //const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      page: 0,
      rowsPerPage: parseInt(event.target.value, 10),
    });
  };

  // function fetchData() {
  //   const params = {
  //     page: controller.page,
  //     size: controller.rowsPerPage,
  //     searchKey,
  //   };
  //   dispatch(getCylinderTagMapList(params));
  // }

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await cylinderTagNoMasterService.getCylinderTagMapList(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchKey(value);
    setController((prev) => ({ ...prev, page: 0 }));
  };


  const deleteRecord = async (id) => {
    try {
      await cylinderTagNoMasterService.editDeleteCylinderTagMap({
        cyl_tag_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (row) => {
    setIsDelete(true);
    setDeleteInfo(row);
  };

  const handleClose = () => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const handleSortClick = (field) => {
    const newOrder = sortBy === field && sortOrder === "asc" ? "desc" : "asc";
    setSortBy(field);
    setSortOrder(newOrder);
  };


  useEffect(() => {
    fetchData();
  }, [controller.page, controller.rowsPerPage, searchKey]);


  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

  console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Cylinder_tag_mapping" }]} />


        <HeaderSection
          title="Cylinder Tag Mapping List"
          addNewPath="/masters/Addcyltagmap"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={["cylinder_no", "tag_no"]}
          labels={["Cylinder No", "Tag No"]}
          filename="Cylinder Tag Mapping List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        excelfileUploads={handleImportExcel}
        />











        <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
          <Table size="small" stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left" 
                  className={styles.table_head} width={'20%'}
                  onClick={() => handleSortClick("tag_no")}
                >
                  Tag No {sortBy === "tag_no" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
                </StyledTableCell>

                <StyledTableCell align="left" width={'20%'}
                  className={styles.table_head}
                  onClick={() => handleSortClick("cylinder_no")}
                >
                  Cylinder No {sortBy === "cylinder_no" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
                </StyledTableCell>
                <StyledTableCell align="center" className={styles.table_head}>
                  Action
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: '#fff' }}>
              {Array.isArray(sortedRows) && sortedRows.map((row) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell align="left" className={styles.list_table_body}>
                    {row.tag_no}
                  </StyledTableCell>

                  <StyledTableCell align="left" className={styles.list_table_body}>
                    {row.cylinder_no}
                  </StyledTableCell>

                  <StyledTableCell align="center">
                    <CustomePopover row={row} handleDelete={false} linkTo="/masters/Addcyltagmap" />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>



        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.cyl_tag_id}
          displayName={`Cylinder No: ${deleteInfo?.cylinder_no}`}
        />

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};


export default ListCyltagmap;
